import { writable } from "svelte/store";

export const currentLessonId = writable<string | null>(null);